/* eslint-disable */
import $ from 'jquery';
import debounce from 'lodash.debounce';
import lazy from 'jquery-lazy';
let jQueryBridget = require('jquery-bridget');
let Slick = require('slick-carousel');
/* eslint-enable */

export default function () {

    $('.truncated-block').readmore({
        speed: 75,
        lessLink: '<a href="#" class="btn btn-link lime-green-color bold">Read less</a>',
        moreLink: '<a href="#" class="btn btn-link lime-green-color bold">Read more</a>'
    });

    $('.lazy').lazy({
        // called before an elements gets handled
        beforeLoad: function (element) {
            let backgroundX = element.data('focus-x');
            let backgroundY = element.data('focus-y');
            let result = String(backgroundX + ' ' + backgroundY);
            element.css('background-position', result);
        },
        effect: 'fadeIn',
        effectTime: 1000,
        threshold: 0
    });

    $('.linkable').on("click", function () {
        let $this = $(this);
        window.location = $this.attr('data-link');
    });


    $(".slider").slick({
        autoplay: true,
        slidesToShow: 6,
        autoplaySpeed: 2000,
        // normal options...
        infinite: true,
        // the magic
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 4
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                dots: true
            }
        }, {
            breakpoint: 300,
            settings: "unslick" // destroys slick
        }]
    });

    $('.linkable').on("click", function () {
        let $this = $(this);
        window.location = $this.attr('data-link');
    });


    $('#toggleNav').click(function () {
        $('#modalNavigation').modal('show');
    });

    $('#closeModal').click(function () {
        $('#modalNavigation').modal('hide');
    });

}
